module.exports = __webpack_public_path__ + "img/hz2.4a4dec5d.png";